import { useRecoilValue } from 'recoil'
import { IMAGE_URL } from '@/constant/IMAGE'
import PreviewImageUpload from './PreviewImage/PreviewImageUpload/PreviewImageUpload'
import PreviewImageClaim from './PreviewImage/PreviewImageClaim/PreviewImageClaim'
import {
  ColAntd,
  Container,
  HeaderContainer,
  IconSvg,
  ImageContainer,
  RowAntd,
  SignedBox,
  Subtitle,
  TextCountFile,
  Title,
  TitleAction,
  TitleBox,
  TitleContainer,
  UploadInputImage,
} from './styles'
import { UploadDocumentClaimResponse } from '@/services/healthClaim/useClaimDocumentUpload/types'
import { ClaimDocumentResponse } from '@/services/healthClaim/useGetClaimDetail/types'
import { DOCUMENT_TYPE, HealthClaimModeEnum } from '@/constant/E_CLAIM'
import DocumentsConsiderationHook from './DocumentsConsideration.hook'
import healthClaimFormAtom from '@/recoil/healthClaimForm'
import { DocumentAction } from '../types'
import React from 'react'

const DocumentsConsideration = ({
  code,
  title,
  signed,
  claimDocuments,
  uploadClaimDocuments,
  dispatch,
  gallery,
}: {
  code: DOCUMENT_TYPE
  title: string
  signed?: boolean
  claimDocuments: ClaimDocumentResponse[]
  uploadClaimDocuments: UploadDocumentClaimResponse[]
  dispatch: React.Dispatch<DocumentAction>
  gallery: { url: string; id: string; code: string; status: string; uploadChannel: string }[]
}) => {
  const healthClaim = useRecoilValue(healthClaimFormAtom)
  const {
    selectedFile,
    fileInputRef,
    uploadStatus,
    uploadProgress,
    triggerFilePicker,
    handleRemoveUploadClaimDocument,
    handleRemoveClaimDocument,
    handleRemoveSelectFile,
    handleDownloadClick,
    handleFileChange,
    uploadFile,
    handleRemovePreview,
  } = DocumentsConsiderationHook({ code, dispatch, claimDocuments })
  const countClaimDocument = claimDocuments.length + uploadClaimDocuments.length
  const isUpload = [HealthClaimModeEnum.CREATE, HealthClaimModeEnum.EDIT].includes(healthClaim.mode)
  const isDownload = [HealthClaimModeEnum.VIEW].includes(healthClaim.mode) && countClaimDocument > 0

  const renderActions = () => (
    <TitleAction>
      {isUpload && uploadStatus !== 'uploading' && (
        <IconSvg src={IMAGE_URL.plusGreenIcon} alt="upload" onClick={triggerFilePicker} />
      )}
      {isDownload && (
        <IconSvg src={IMAGE_URL.downloadGreenIcon} alt="download" onClick={handleDownloadClick} />
      )}
    </TitleAction>
  )

  return (
    <Container>
      <HeaderContainer>
        <TitleContainer>
          <TitleBox>
            <Title>{title}</Title>
            {signed && <SignedBox bordered={false}>เซ็นสำเนาถูกต้อง</SignedBox>}
            <TextCountFile>{countClaimDocument} ไฟล์</TextCountFile>
          </TitleBox>
          {renderActions()}
        </TitleContainer>
        <Subtitle>อัปโหลดได้เฉพาะไฟล์ .jpeg, .png, pdf เท่านั้น</Subtitle>
      </HeaderContainer>
      <ImageContainer>
        <RowAntd gutter={[16, 24]}>
          {claimDocuments?.map((document, index) => {
            return (
              <ColAntd key={index}>
                <PreviewImageClaim
                  id={document?.id}
                  src={document?.path}
                  gallery={gallery}
                  dateTime={document?.timestamp}
                  mimeType={document?.mimeType}
                  onRemove={handleRemoveClaimDocument}
                  onRemovePreview={handleRemovePreview}
                />
              </ColAntd>
            )
          })}
          {uploadClaimDocuments?.map((document, index) => {
            return (
              <ColAntd key={index}>
                <PreviewImageClaim
                  id={document?.id}
                  src={document?.url}
                  gallery={gallery}
                  dateTime={document?.timestamp}
                  mimeType={document?.mimeType}
                  onRemove={handleRemoveUploadClaimDocument}
                  onRemovePreview={handleRemovePreview}
                />
              </ColAntd>
            )
          })}
          {selectedFile && (
            <ColAntd>
              <PreviewImageUpload
                file={selectedFile}
                status={uploadStatus}
                progress={uploadProgress}
                retryUpload={uploadFile}
                removeSelectFile={handleRemoveSelectFile}
              />
            </ColAntd>
          )}
        </RowAntd>
      </ImageContainer>
      <UploadInputImage
        type="file"
        accept="image/*,application/pdf,.pdf"
        ref={fileInputRef}
        onChange={handleFileChange}
      />
    </Container>
  )
}

export default DocumentsConsideration
